import { toast } from "react-toastify";

import { GetCouponResponseBodyType } from "@intelligems/ig-types";

import { api } from "../api";

export const fetchCoupon = async (
  code: string
): Promise<GetCouponResponseBodyType | null> => {
  try {
    const resp = await api.get<GetCouponResponseBodyType>(
      `/v2/stripe/coupons/${code}`
    );
    return resp.data;
  } catch (e) {
    toast.error("error validating code");
    return null;
  }
};
